export default function (array_of_objects, id) {
  for (let index = 0; index < array_of_objects.length; index++) {
    if (array_of_objects[index].id === id) {
      return index
    }
  }

  return false
}
